import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState } from "react";
import { useMediaQuery, CustomDrawer, DrawerHeader, DrawerFooter } from "componentLibrary";
import CustomizeColumnsView from "./CustomizeColumnsView";
import { jsx as _jsx } from "react/jsx-runtime";
var CustomizeColumnsDrawer = function CustomizeColumnsDrawer(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    transactionColumns = _ref.transactionColumns,
    selectedColumns = _ref.selectedColumns,
    setSelectedColumns = _ref.setSelectedColumns,
    onSave = _ref.onSave,
    organizationId = _ref.organizationId,
    customColumns = _ref.customColumns;
  var isPhone = useMediaQuery(function (theme) {
    return theme.breakpoints.only("sm");
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editingColumn = _useState2[0],
    setEditingColumn = _useState2[1];
  return /*#__PURE__*/_jsx(CustomDrawer, {
    open: open,
    onClose: onClose,
    width: "1082px",
    header: /*#__PURE__*/_jsx(DrawerHeader, {
      title: "Customize Table",
      onClose: onClose
    }),
    body: /*#__PURE__*/_jsx("div", {
      style: {
        height: "100%"
      },
      children: /*#__PURE__*/_jsx(CustomizeColumnsView, {
        customColumns: customColumns,
        transactionColumns: transactionColumns,
        selectedColumns: selectedColumns,
        setSelectedColumns: setSelectedColumns,
        isPhone: isPhone,
        editingColumn: editingColumn,
        setEditingColumn: setEditingColumn,
        organizationId: organizationId
      })
    }),
    footer: /*#__PURE__*/_jsx(DrawerFooter, {
      cancelClickHandler: onClose,
      submitClickHandler: onSave,
      disabled: editingColumn !== false
    })
  });
};
export default CustomizeColumnsDrawer;